import { Doughnut } from 'vue-chartjs'
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    ArcElement
)

export default {
    name: 'DoughnutChart',
    components: {
        Doughnut
    },
    props: {
        chartData: {
            type: Object,
            required: false,
            default: () => ({ labels: [], datasets: [] })
        },
        options: {
            type: Object,
            required: false,
            default: () => ({})
        },
        height: {
            type: [Number, String],
            default: null
        },
        width: {
            type: [Number, String],
            default: null
        },
        plugins: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            internalData: null,
            internalOptions: null
        }
    },
    computed: {
        activeData() {
            return this.internalData || this.chartData
        },
        activeOptions() {
            return this.internalOptions || this.options
        }
    },
    render(h) {
        const containerStyle = {
            position: 'relative',
            width: this.width
                ? (typeof this.width === 'number' ? `${this.width}px` : this.width)
                : '100%',
            height: this.height
                ? (typeof this.height === 'number' ? `${this.height}px` : this.height)
                : '100%'
        }
        const props = {
            chartData: this.activeData,
            chartOptions: this.activeOptions,
            plugins: this.plugins,
            styles: { height: '100%', width: '100%' }
        }
        return h('div', { style: containerStyle }, [
            h(Doughnut, {
                props,
                ref: 'doughnutChart'
            })
        ])
    },
    methods: {
        renderChart(data, options) {
            this.internalData = data
            this.internalOptions = options
            this.$forceUpdate()
        }
    }
}
